export enum TipoMotivoEnum {
  REEMBOLSO = "REEMBOLSO",
  CANCELAMENTO = "CANCELAMENTO",
  CONFIRMACAO_MANUAL = "CONFIRMACAO_MANUAL",
  ATRASO = "ATRASO",
  IMPEDIMENTO = "IMPEDIMENTO",
}
